document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('input[data-connected-product-handle]').forEach((input) => {
    input.addEventListener('click', async () => {
      const handle = input.dataset.connectedProductHandle?.trim();
      if (!handle) return;

      // Walk upward until we find an ancestor that contains a .card-gallery
      let node = input;
      let gallery = null;
      while (node && node !== document.documentElement) {
        gallery = node.querySelector?.('.card-gallery');
        if (gallery) break;
        node = node.parentElement;
      }

      if (!gallery) {
        console.warn('❌ Could not find .card-gallery near swatch');
        return;
      }

      const productCard = gallery.closest('product-card');
      if (!productCard) {
        console.warn('❌ Could not find <product-card> container');
        return;
      }

      const mediaRatio = productCard?.querySelector('[ref="cardGallery"]')?.style.getPropertyValue('--gallery-aspect-ratio');


      // Preserve hidden-swatches state
      const hiddenToggle = productCard.querySelector('.hidden-swatches__count');
      const wasOpen = productCard.querySelector('.variant-option__swatch[slot="overflow"]')

      try {
        const res = await fetch(`/products/${handle}?section_id=card-gallery`, {
          credentials: 'same-origin',
        });
        if (!res.ok) throw new Error(`❌ Failed to fetch gallery HTML (HTTP ${res.status})`);

        const html = await res.text();
        const temp = document.createElement('div');
        temp.innerHTML = html;

        const newGallery = temp.querySelector('.card-gallery');
        const newPriceElement = temp.querySelector('[ref="priceContainer"]');
        if (!newGallery) throw new Error('❌ No .card-gallery found in returned HTML');

        // Find price container NOT inside the current gallery
        const priceTargets = Array.from(productCard.querySelectorAll('[ref="priceContainer"]'));
        const outsidePrice = priceTargets.find((el) => !gallery.contains(el)) || priceTargets[1] || null;

        // Replace gallery
        gallery.replaceWith(newGallery);

        // Update outside price if present
        if (newPriceElement && outsidePrice) {
          outsidePrice.innerHTML = newPriceElement.innerHTML;
        }

       if(mediaRatio) productCard?.querySelector('[ref="cardGallery"]')?.style.setProperty('--gallery-aspect-ratio', mediaRatio);
        
      } catch (err) {
        console.error('⚠️ Failed to replace gallery:', err);
      }
    });
  });
});
